/** Parse CRA `REACT_APP_*` flags. Unset / anything other than `"true"` is off. */
const isEnvFlagEnabled = (value: string | undefined): boolean =>
  String(value ?? '').trim().toLowerCase() === 'true';

/**
 * Feature flags controlled by environment variables.
 * Restart the CRA/webpack dev server after changing `.env` values.
 */
export const FEATURE_FLAGS = {
  /** Show the Semantic search toggle on job-description-summary. */
  enableSemanticSearch: isEnvFlagEnabled(process.env.REACT_APP_ENABLE_SEMANTIC_SEARCH),
  /** Allow outreach Send / Confirm (requires backend send API). */
  enableOutreachSend: isEnvFlagEnabled(process.env.REACT_APP_ENABLE_OUTREACH_SEND),
} as const;
